<template>
	<div class="bcgl">
		<div style="margin: 0rem 0 0 0rem; border: 1px #DDDDDD solid;">
			<el-card class="box-card">
				<div slot="header">
					<el-row style="margin-bottom: 20px">
						<el-col :span="24">
							<div style="line-height: 3rem; font-size: 1.5rem;">问题上报</div>
						</el-col>

					</el-row>
					<el-row style="text-align: left">
						<el-form :inline="true" :model="searchForm" @keyup.enter.native="searchData()">
							<el-form-item label="姓名" >
								<el-input clearable @change="changeIndex" v-model="searchForm.sbrxm" ></el-input>
							</el-form-item>
							<el-form-item label="上报日期">
								<el-date-picker
										@change="changeIndex"
										v-model="startTime"
										type="datetimerange"
										value-format="yyyy-MM-dd HH:mm:ss"
										range-separator="至"
										start-placeholder="开始日期"
										end-placeholder="结束日期">
								</el-date-picker>
							</el-form-item>
							<el-form-item label="状态">
								<el-select clearable @change="changeIndex" v-model="searchForm.status" placeholder="请选择" style="float: left;">
									<el-option label="未审核" value="4"></el-option>
									<el-option label="审核通过" value="0"></el-option>
									<el-option label="审核被拒" value="1"></el-option>
									<el-option label="审批通过" value="2"></el-option>
									<el-option label="审批被拒" value="3"></el-option>
									<el-option label="撤销" value="5"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item>
								<el-button @click="searchData()">查询</el-button>
<!--								<el-button v-if="isAuth('equip:out')" type="primary" @click="addOrUpdate()"  style="display: inline;">出库</el-button>-->
							</el-form-item>
						</el-form>
					</el-row>
				</div>

				<el-table
						@selection-change="selectionChangeHandle"
						:header-cell-class-name="handleHeaderClass"
						@sort-change="handleTableSort"
						:data="contractList" v-loading="loading"  style="text-align: center; width: 100%;">
					<el-table-column
							type="selection"
							header-align="center"
							align="center"
							width="50"

					>
					</el-table-column>
					<el-table-column prop="t.userid" label="上报人" sortable="custom">
						<template slot-scope="scope">
							{{scope.row.sbrxm}}
						</template>
					</el-table-column>
					<el-table-column prop="u.zzdyqc" label="部门" sortable="custom">
						<template slot-scope="scope">
							{{scope.row.dept}}
						</template>
					</el-table-column>
					<el-table-column  label="工号" prop="workNumber">

					</el-table-column>
					<el-table-column  label="上报时间"  prop="t.sbsj" sortable="custom">
						<template slot-scope="scope">
							{{scope.row.sbsj}}
						</template>
					</el-table-column>

<!--					<el-table-column show-overflow-tooltip label="上报地点" prop="wzxx" >-->

<!--					</el-table-column>-->

					<el-table-column  label="状态" prop="t.status" sortable="custom">
						<template slot-scope="scope">
							<span>{{getStatus(scope.row)}}</span>
						</template>
					</el-table-column>
					<el-table-column  label="描述" show-overflow-tooltip prop="wtms">

					</el-table-column>

					<el-table-column label="操作" :render-header="renderHeader">
						<template slot-scope="scope">
							<el-button type="text" size="mini"   @click="showInfo(scope.row)">查看附件</el-button>
							<el-button type="text" size="mini"   @click="showLog(scope.row)">审批流程</el-button>

<!--							<el-button type="text" size="mini" v-if="isAuth('equip:delete')" @click="deleteHandle(scope.row.id)">删除</el-button>-->
						</template>
					</el-table-column>
				</el-table>
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentNo"
				 :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal">
				</el-pagination>
			</el-card>
		</div>
		<el-dialog
				style="text-align: left"
				title="导出"
				:visible.sync="exportVisible"
		>
			<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
			<el-checkbox-group v-model="fieldList" @change="handleCheckedItemChange">
				<el-checkbox v-for="field in fields" :label="field.value" :key="field.value">{{field.name}}</el-checkbox>
			</el-checkbox-group>
			<form ref="exportForm" method="post" :action="this.$request.defaults.baseURL+'/bjba/wtsb/exportExcel?access_token='+this.$store.getters.token"  target="_blank">
				<input type="hidden" v-for="(value,key,index) in searchForm" :name="key"  :value="value" />
				<input type="hidden" name="fileds" value="" ref="fileds"/>
			</form>
			<span slot="footer" class="dialog-footer">
    <el-button @click="exportVisible = false">取 消</el-button>
    <el-button type="primary" @click="exportExcel">确 定</el-button>
  </span>
		</el-dialog>
		<out-log v-if="showInfoVisible" ref="showInfo"></out-log>
		<question-log v-if="questionLogVisible" ref="questionLog"></question-log>

	</div>
</template>
<script >
	import {
		Vue,
		Component
	} from 'vue-property-decorator'

	import OutLog from './attach'
	import QuestionLog from  './question-log'
	import fa from "element-ui/src/locale/lang/fa";
	const exportFields=[
		{value:"sbsj",name:"上报时间"},
		{value:"wzxx",name:"上报位置"},
		{value:"longitude",name:"经度"},
		{value:"latitude",name:"维度"},
		{value:"status",name:"处理状态"},
		{value:"cljg",name:"处理结果"},
		{value:"wtms",name:"发放时间"},
		{value:"sbrxm",name:"上报人姓名"},
		{value:"workNumber",name:"上报人工号"},
		{value:"bmmc",name:"部门名称"},
		{value:"shrxm",name:"审核人姓名"},
		{value:"shsj",name:"审核时间"},
		{value:"sprxm",name:"审批人姓名"},
		{value:"spsj",name:"审批时间"}

	]
	@Component({
		name: 'contractinfo',
		components:{
			OutLog,
			QuestionLog
		}
	})
	export default class contractinfo extends Vue {
		customerVisible=false
		currentNo = 1;
		pageSize= 10;
		pageTotal = 0;
		activeNames=[];
		showbmxxVisible = false;
		customerList=[]
		showfileVisible=false
		startTime=[]
		showInfoVisible=false
		questionLogVisible =false
		types=[]
		searchForm= {
			sbrxm:'',
			startTimest:'',
			startTimeed:'',
			status:''
		}

		endTime=[]
		bmxx=[]
		amount=['','']
		contractList=[]
		loading = false;
		orders=[]
		dataListSelections=[];
		sjbm=[]
		selectBm=''
		isIndeterminate=false
		exportVisible=false
		checkAll=false
		fields=exportFields
		filedValues=exportFields.map(item => item.value)
		fieldList=[]
		created() {
			this.getTypes()
			this.searchData();
			this.getbmxx();
		}

		getBm(user) {
			var ubmid ;
			var bmmc;
			ubmid = user.bmid
			for(var i=0; i<this.bmxx.length;i++) {

				if(this.bmxx[i].bmid == ubmid) {
					bmmc = this.bmxx[i].bmmc
				}
			}
			return bmmc;
		}
		getStatus(row){
			var text =''
			switch (row.status) {
				case '0':
					text = "审核通过";
					break;
				case '1':
					text = "审核被拒";
					break;
				case '2':
					text = "审批通过";
					break;
				case '3':
					text = "审批被拒";
					break;
				case '4':
					text = "未审核";
					break;
				case '5':
					text = "撤销";
					break;
				default:
					text = "未审核";

			}
			return text
		}
		getbmxx() {
			let that = this;
			this.$request.get('/bjba/yhgl/getbmxx').then(res => {
				console.log("bmxx:", res);
				that.bmxx = res.data;
			})
		}
		handleSizeChange(val) {
			this.pageSize = val;
			this.searchData();
		}
		handleCurrentChange(val) {
			this.currentNo = val;
			this.searchData();
		}
// 设置列的排序为我们自定义的排序
		handleHeaderClass({ column }) {
			if(!column.multiOrder) column.multiOrder =''
			column.order = column.multiOrder
		}
		handleOrderChange (orderColumn, orderState) {
			let result = this.orders.find(e => e.orderColumn === orderColumn)
			if (result) {
				if(orderState)
					result.orderState = orderState
				else {
					var j =this.orders.indexOf(result);
					if(j !== -1) {
						this.orders.splice(j,1);
					}
				}
			} else {
				this.orders.push({
					orderColumn: orderColumn,
					orderState: orderState
				})
			}
			this.searchData()
		}
// 上面缺点是只能通过点击表头切换排序状态，点击小三角排序不会触发，处理sort-change事件和点击表头一样
// 列表排序
		handleTableSort({ column }) {
			console.log(column.orderfield)
			column.multiOrder = column.order
			this.handleOrderChange(column.property, column.multiOrder)
		}
		getParams() {

			if(this.startTime &&this.startTime.length==2){
				this.searchForm.startTimest = this.startTime[0]
				this.searchForm.startTimeed = this.startTime[1]
			} else{
				this.searchForm.startTimest = ''
				this.searchForm.startTimeed = ''
			}
			this.searchForm.page = this.currentNo
			this.searchForm.pagesize = this.pageSize
			this.searchForm.orders = encodeURI(JSON.stringify(this.orders))
		}
		handleCheckAllChange(val) {
			this.fieldList = val ? this.filedValues: [];
			this.isIndeterminate = false;
		}
		handleCheckedItemChange(value) {
			let checkedCount = value.length;
			this.checkAll = checkedCount === this.filedValues.length;
			this.isIndeterminate = checkedCount > 0 && checkedCount < this.fields.length;
		}

		showExportDialog() {
			this.exportVisible = true
		}
		renderHeader (h) {
			return (
					<div class="clearfix">
						<span>操作</span>
						<el-button style="padding:5px;float:right" size="mini"
								   onClick={()=>this.showExportDialog()}>导出</el-button></div>
			)
		}
		exportExcel() {
			var filedLast = this.fields.filter(filed=>{
				return this.fieldList.indexOf(filed.value) !==-1
			})
			if(filedLast && filedLast.length>0) {
				this.getParams();
				this.$refs.fileds.value = JSON.stringify(filedLast)
				this.$refs.exportForm.submit();
			} else {
				this.$message({
					message: '请选择字段',
					type: 'error',
					duration: 1500
				})
				return
			}
		}
		preview(row){
			// var viewUrl = this.$request.defaults.baseURL+'/bjba/contract/preview/'+id+'?type=1&access_token='+this.$store.getters.token
			// window.open(viewUrl)
			this.showfileVisible = true
			this.$nextTick(() => {
				this.$refs.showfile.init(row)
			})
		}

		getRowKeys(row) {
			return row.id;
		}
		showInfo(row){

			this.showInfoVisible = true
			this.$nextTick(() => {
				this.$refs.showInfo.init(row)
			})
		}
		showLog(row){

			this.questionLogVisible = true
			this.$nextTick(() => {
				this.$refs.questionLog.init(row)
			})
		}
		download(id) {
			var downUrl = this.$request.defaults.baseURL+'/bjba/contract/download/'+id+'?type=1&access_token='+this.$store.getters.token
			window.location.href = downUrl
		}
		changeIndex() {
			this.currentNo = 1
		}
		searchData() {

			this.getParams()
			this.loading = true;
			this.$request({
					url: '/bjba/wtsb/page',
					method: 'get',
					params: this.searchForm
				})
				.then(response => {
					this.loading = false;
					console.log(response);
					let data = response.data;
					if (data.code == 200) {
						this.contractList = data.data.data;
						this.pageTotal = data.data.count
					} else {
						this.$message.error(data.message)
					}
				})
				.catch(error => {
					this.loading = false;
					console.log(error)
					this.$message.error(error)
				});
		}
		// 多选
		selectionChangeHandle (val) {
			this.dataListSelections = val
		}
		addOrUpdate(val) {

			if(!this.dataListSelections|| this.dataListSelections.length==0) {
				this.$message.warning("请选择装备")
				return
			}
			this.customerVisible = true
			this.$nextTick(() => {
				this.$refs.customer.init(this.dataListSelections)
			})
		}
		deleteHandle (id) {
			let ids = id ? [id] : this.dataListSelections.map(item => {
				return item.id
			})
			if(!ids || ids.length==0) return
			this.$confirm(`确定进行[删除]操作?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: `/bjba/equip/datil/delete`,
					method: 'post',
					data: ids
				}).then(({data}) => {
					if (data && data.code === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500
						})
						this.searchData()
					} else if(data && data.code ==500) {
						this.$message({
							message: data.message,
							type: 'error',
							duration: 1500
						})
					}
				})
			}).catch(() => {
			})
		}

		getTypes() {
			this.$request.get('/bjba/equip/type/getAll').then(res => {

				this.types = res.data.data;
			})
		}
		getTypeName(typeid){
			var typeName =""
			if(typeid){
				for(var i=0;i<this.types.length;i++) {
					if (typeid == this.types[i].id) {
						typeName = this.types[i].name
						break
					}
				}
				return typeName
			}
			return typeName
		}
	}
</script>
<style lang="scss" scoped>
	.bcgl {}
</style>
